export const LanguageActionTypes = {
    SET_LANGUAGE: 'SET_LANGUAGE'
}